import SingleMyUHLParcelContainer from "../containers/SingleMyUHLParcelContainer";

const SingleMyUHLParcelPage = () => {
    return <SingleMyUHLParcelContainer />;
};

export default SingleMyUHLParcelPage;
